const userReducer = (state = {}, action) => {
  switch (action.type) {
  case 'GET_USER':
  case 'UPDATE_USER':
    if (action.error) return state;
    return action.data;

  default:
    return state;
  }
};

export default userReducer;
